document.querySelectorAll('.add-to-cart').forEach((b)=> b.closest('form').addEventListener('submit',function (e) {
    e.preventDefault();
    e.stopPropagation();
    let btn = b;
    if(e.target.querySelector('[data-name="size"]') && !e.target.querySelector('[data-name="size"]:checked')){
        e.target.querySelector('.swatch-option.size').classList.add('error');
       setTimeout(function (){e.target.querySelector('.swatch-option.size').classList.remove('error');},1400);
        if(!e.target.querySelector('.swatch-option.size .size-error'))
            e.target.querySelector('.swatch-option.size').insertAdjacentHTML('beforeend','<div class="size-error">Please select the size</div>');
        else
            e.target.querySelector('.swatch-option.size .size-error').style.display = 'block';

        return false;
    }
    if(btn.hasAttribute('redirect'))
        return false;
    if(typeof (btn.timer) !=='undefined' && btn.timer)
        clearTimeout(btn.timer);

    btn.setAttribute('disabled','');
    btn.classList.add('loading');
    btn.querySelector('.btn-inside').innerHTML = window.productStrings.adding;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(btn.closest('form'))
    })
        .then((response) => {
            return response.json();
        })
        .then((response)=>{
            fetch(window.Shopify.routes.root + 'cart.js').then((re)=> {return re.json()} ).then((re)=> document.dispatchEvent(new CustomEvent('cart:updated',{'detail': re}))).catch((err)=>console.log(err))

            document.querySelector('notify-bar').notify('<span class="cart-notice">'+window.productStrings.addedHTML+'</span>',false);
            btn.querySelector('.btn-inside').innerHTML = window.productStrings.added;
            btn.addEventListener('click',_addCartRedirects);
            btn.setAttribute('redirect','');
            btn.removeAttribute('disabled');
            btn.classList.remove('loading');
            btn.timer = setTimeout(()=>btn.querySelector('.btn-inside').innerHTML = window.productStrings.viewCart,4000);

               try {
                   var item = {
                       Name: response.product_title,
                       ProductID: response.product_id,
                       Categories: [response.product_type],
                       ImageURL: response.image,
                       URL: window.location.href,
                       Brand: response.vendor,
                       Price: response.original_price/100
                       //CompareAtPrice: {{ product.compare_at_price_max|money|json }}
                   };
                   _learnq.push(['track', 'Added to Cart', item]);
               }  catch (e){}
            setTimeout(()=>document.querySelector('notify-bar').hidden = true, 4000);
        })
        .catch((error) => {
            document.querySelector('notify-bar').notify(window.productStrings.error,true);
            btn.removeAttribute('disabled');
            btn.classList.remove('loading');
            btn.querySelector('.btn-inside').innerHTML = window.productStrings.addToCart;
            console.error('Error:', error);
        });

    return false;
}));
function _addCartRedirects(e){
    e.preventDefault();
    e.stopPropagation();
    window.location = Shopify.routes.root+'cart';
    return false;
}